import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Col, message, Row, Table } from "antd";
import { EditOutlined } from "@ant-design/icons";

import { patchAdviseeActionPlans } from "apis/advisee";
import { constructColumn } from "utils/table/table";

import Title from "components/Title/Title";
import SectionContainer from "components/SectionContainer/SectionContainer";

import AddActionPlanModal from "./components/AddActionPlanModal/AddActionPlanModal";
import Locale from "react-intl-universal";

// const getActionPlansTableColumns = [
//   constructColumn('Ares', 'area', { hasSorter: true }),
//   constructColumn('Suggested Action', 'action'),
//   constructColumn('Initiator', 'initiator'),
//   constructColumn('Date of Action', 'actionDate', { hasSorter: true, isDate: true }),
//   constructColumn('Decision', 'decision')
// ];

const Summary = ({ actionPlans = [] }) => {
  const getActionPlansTableColumns = [
    constructColumn(Locale.get("actionPlan.areas"), "area", {
      hasSorter: true,
    }),
    constructColumn(Locale.get("actionPlan.suggestedAction"), "action"),
    constructColumn(Locale.get("actionPlan.initiator"), "initiator"),
    constructColumn(Locale.get("actionPlan.actionDate"), "actionDate", {
      hasSorter: true,
      isDate: true,
    }),
    constructColumn(Locale.get("actionPlan.decision"), "decision"),
  ];
  const { id: adviseeId } = useParams();
  const [showAddActionPlanModal, setShowAddActionPlanModal] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(-1);

  const updateActionPlan = (payload, successMessage) => {
    patchAdviseeActionPlans(adviseeId, payload)
      .then(() => {
        message.success(successMessage);
        handleOnModalCancelButtonClick();
      })
      .catch(() => {
        message.error(
          "Error in updating action plans. Please check your connection and try again."
        );
      });
  };

  const handleOnRowSelect = (index) => {
    setSelectedRowIndex(index);
    setShowAddActionPlanModal(true);
  };

  const handleOnActionPlanModalOk = (actionPlan) => {
    if (selectedRowIndex > -1) {
      const editedActionPlan = [...actionPlans];
      editedActionPlan[selectedRowIndex] = actionPlan;
      updateActionPlan(
        editedActionPlan,
        Locale.get("actionPlan.updateSuccess")
      );
    } else {
      const newActionPlans = [...actionPlans, actionPlan];
      updateActionPlan(
        newActionPlans,
        Locale.get("actionPlan.newActionPlanAdded")
      );
    }
  };

  const handleOnModalRemoveButtonClick = () => {
    const newActionPlans = [...actionPlans];
    newActionPlans.splice(selectedRowIndex, 1);
    updateActionPlan(newActionPlans, Locale.get("actionPlan.removeSuccess"));
  };

  const handleOnModalCancelButtonClick = () => {
    setShowAddActionPlanModal(false);
    setSelectedRowIndex(-1);
  };

  return (
    <>
      <SectionContainer>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 24 }}
        >
          <Col>
            <Title>{Locale.get("actionPlan.actionPlanTitle")}</Title>
          </Col>
          <Col>
            <Button
              type="primary"
              icon={<EditOutlined />}
              style={{ float: "right" }}
              onClick={() => setShowAddActionPlanModal(true)}
            >
              {Locale.get("actionPlan.addNewActionPlan")}
            </Button>
          </Col>
        </Row>
      </SectionContainer>
      <SectionContainer>
        <Table
          dataSource={actionPlans}
          columns={getActionPlansTableColumns}
          pagination={false}
          rowKey={(record) => record.label}
          style={{ width: "100%" }}
          scroll={{ x: true }}
          onRow={(record, index) => ({
            onClick: () => handleOnRowSelect(index),
          })}
        />
      </SectionContainer>
      {showAddActionPlanModal && (
        <AddActionPlanModal
          defaultValues={actionPlans[selectedRowIndex]}
          visible={showAddActionPlanModal}
          onCancel={handleOnModalCancelButtonClick}
          onOk={handleOnActionPlanModalOk}
          onRemove={handleOnModalRemoveButtonClick}
        />
      )}
    </>
  );
};

export default Summary;
